import { Language } from "../types";

export default (lang : Language) => {
    const copies = require('./' + lang + '.json');

    return {
        ...copies,
    }
}
